import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "w-6/12 px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_4 = { class: "text-center" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';

import Pages from "@/classes/Pages";

import { useRouter } from 'vue-router';
import { onMounted, ref, computed } from 'vue';

import { PageInterface } from '@/interfaces/BaseInterface';


export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();

// Data
const loader    = ref(false);
const showError = ref(false);
const errorMsg  = ref(null);

const items = ref<PageInterface[]>([]);
const hasPermission = computed<boolean>( () => window.$hasPermission('view-homepage-setup') || window.$hasPermission('update-homepage-contents'));

// Methods
const indexSystemNotification = () => {
    loader.value = true;

    Pages.fetch()
        .then((response: any) => {
            loader.value = false;

            items.value = response.data.items;
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
    loader.value = false;
}

const headers: { text: string }[] = [
    { text: 'Page' },
];

onMounted( () => {
    indexSystemNotification();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, { title: "Pages" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(DataTable, {
          headers: headers,
          count: items.value.length
        }, {
          body: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (hasPermission.value)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
                      _createElementVNode("td", _hoisted_3, _toDisplayString(item.label), 1),
                      _createElementVNode("td", _hoisted_4, [
                        _createVNode(ActionButton, {
                          "edit-btn": "",
                          onClick: ($event: any) => (_unref(router).push(`/contents/pages/show/${item.id}`))
                        }, null, 8, ["onClick"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          _: 1
        }, 8, ["count"])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[1] || (_cache[1] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})